import {useRef, useState} from 'react';
import { SLowcodeList} from 'shj-components'
import {fileConfirm} from '@/utils/file'
import config from './config.ts';
import {Select} from 'antd';
import KeepAlive from 'react-activation';
import {useNavigate} from 'react-router-dom'
import {tableApiFunc} from "@/utils/data.ts";
import {qualityMoneyAccountExportQualityMoney, qualityMoneyAccountPage} from "@/services/qualityMoneyAccount.ts";
import {useRequest} from "ahooks";
import {moneyRender} from "@/utils";
import {fetchVendorInfoList} from "@/services";
import { addFn } from './add/index.tsx';
import { authDict } from 'shj-utils';
import { esigncompanyconfig } from '@/services/fmsConfig.ts';

const AccountList = (props: any) => {
    const listRef = useRef<any>();
    const { Option } = Select;
    const history = useNavigate()
    const [vendorList, setVendorList] = useState([]);
    const [esigncompanyList, setEsigncompany] = useState([]);
    let { loading: exportLoading, runAsync } = useRequest(qualityMoneyAccountExportQualityMoney, { manual: true });
    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const vendorRes: any = await fetchVendorInfoList();
                const esigncompany = await esigncompanyconfig(1, 10, {})
                const vendorList = vendorRes.data??[];
                const esigncompanyList = esigncompany.records
                setEsigncompany(esigncompanyList);
                setVendorList(vendorList)

                resolve({
                    vendorList,
                });
            } catch (e) {
            }
        });
    };
    // 新增
    const onAdd = async (record: any) => {
        addFn({
            fn: () => {
                listRef.current.reload();
            },
            ...record,
            record,
            companyList: props.companyList,
            vendorList: vendorList
        });
    };
    const onSearchEsigncompany = async (value) => {
        const esigncompany = await esigncompanyconfig(1, 10, {companyFullName: value})
        const esigncompanyList = esigncompany.records
        setEsigncompany(esigncompanyList);
    }
    const toDetail = (record) => {
        history('/config/serviceConfig/retentionMoneyManagement/accountDetail/' + record.id);
    };
    const onExport = () => {

        let query = listRef.current?.getSearch?.()?.getFieldsValue?.();
        runAsync({
            params: {
                ...query,
                companyCodes: query.companyCodes && (query.companyCodes || []).join(',')
            }
        }).then(() => {
            fileConfirm()
        })
    }
    const extension = {
        request: {
            fetchList: tableApiFunc(qualityMoneyAccountPage, { fieldNames: { current: 'current' } }),
            getStatusOptions
        },
        events: { onExport,onAdd: () => onAdd(null) },
        // auth: authDict,
        status: {
            btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
            exportLoading: exportLoading,
        },
        customRender: {
            companyNameRender(text: any, record: any) {
                return authDict['accountDetail'] ? (
                    <div
                      onClick={() => toDetail(record)}
                      style={{ color: '#1677ff', cursor: 'pointer' }}
                    >
                      {text}
                    </div>
                  ) : (
                    <div>{text}</div>
                  )
            },
            setCompany({ key, name, form }: any) {
                return (
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {(props.allCompanyList || []).map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.orgId}>
                                    {item.companyName}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
            setEsigncompany({ key, name, form }: any) {
                return (
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={true}
                        onSearch={onSearchEsigncompany}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {esigncompanyList.map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.id}>
                                    {item.companyFullName}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },

            setIsRefund(text: any, record: any) {
                return <span>{record.isRefund ? '是' : '否'}</span>;
            },
            setAccountBalance(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setFrozenAmount(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setIncomeFreezeAmount(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setAvailableAmount(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            }
        },
    };

    return <SLowcodeList config={config} ref={listRef} {...extension}  searchMode="group"/>;
};

export default (props: any) => {
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <AccountList {...props} />
        </KeepAlive>
    );
};
